import { get } from "./client";
import { API_ENDPOINTS } from "./endpoints";

const sanitizeLimit = (value) => {
  const numeric = Number(value);
  if (Number.isNaN(numeric)) return 20;
  return Math.min(100, Math.max(1, Math.trunc(numeric)));
};

const sanitizeOffset = (value) => {
  const numeric = Number(value);
  if (Number.isNaN(numeric)) return 0;
  return Math.max(0, Math.trunc(numeric));
};

const extractClientRecord = (response) => {
  if (!response || response.error) return null;
  if (response?.client && typeof response.client === "object") return response.client;
  if (Array.isArray(response?.clients) && response.clients[0]) return response.clients[0];
  if (response?.id || response?.client_id) return response;
  return null;
};

const getClientsList = (response) => {
  if (!response || response.error) return [];
  if (Array.isArray(response?.clients)) return response.clients;
  if (Array.isArray(response?.data)) return response.data;
  if (Array.isArray(response?.items)) return response.items;
  if (Array.isArray(response)) return response;
  return [];
};

export const getPublicClients = async () => {
  const response = await get(API_ENDPOINTS.CLIENTS.PUBLIC_LIST, { skipAuth: true });

  if (response?.error) {
    return response;
  }

  return {
    clients: getClientsList(response),
  };
};

export const getClientById = async (clientId) => {
  const response = await get(API_ENDPOINTS.CLIENTS.GET_BY_ID(clientId));

  if (response?.error) {
    return response;
  }

  const client = extractClientRecord(response);
  return client ? client : { error: { message: "Client not found." } };
};

export const getPhoneNumbersByClientId = async (clientId, params = {}) => {
  const { limit = 50, offset = 0 } = params;
  const endpoint = `${API_ENDPOINTS.PHONE_NUMBERS.LIST_BY_CLIENT(clientId)}?limit=${sanitizeLimit(limit)}&offset=${sanitizeOffset(offset)}`;

  const response = await get(endpoint);
  if (response?.error) {
    return response;
  }

  const phoneNumbers = Array.isArray(response?.phone_numbers)
    ? response.phone_numbers
    : Array.isArray(response?.data)
      ? response.data
      : Array.isArray(response)
        ? response
        : [];

  return {
    phoneNumbers,
    total: Number(response?.total || phoneNumbers.length),
  };
};
